import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { useFloatingTooltip } from 'hooks/useFloatingTooltip';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * @param {boolean} show - Whether to display the indicator.
 * @param {dayjs.Dayjs} time - The time to compare and display (dayjs object).
 * @param {number} originalOffset - The original time zone offset in minutes.
 * @param {string} timeFormat - Format string for displaying times (e.g., 'h:mm A').
 * @returns {JSX.Element} A clock icon with a tooltip showing the local time.
 */
const TzDifferenceIndicator = ({
  show,
  time,
  originalOffset,
  displayTz,
  timeFormat = 'h:mma',
}) => {
  const originalTime = useMemo(() => time.utc().utcOffset(originalOffset).tz(displayTz), [time, originalOffset]);
  const tooltipMessage = `Event location time is ${originalTime.format(`${timeFormat} z`)}`;
  const {
    showTooltip,
    hideTooltip,
    updateTooltip,
    tooltipElement,
  } = useFloatingTooltip(tooltipMessage, { position: 'right' });
  if (!show) return;
  return (
    <>
      <span
        onMouseEnter={e => {
          showTooltip();
          updateTooltip(e);
        }}
        onMouseMove={e => updateTooltip(e)}
        onMouseLeave={hideTooltip}
        className="tz-difference-indicator"
      >
        <FontAwesomeIcon
          icon={['fal', 'clock']}
        />
      </span>
      {tooltipElement}
    </>
  );
};

export default TzDifferenceIndicator;
